import { TUpdateWorkflowTemplateVersionParams } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export const updateWorkflowTemplateVersion = async (
  workflowTemplateVersionId: string,
  data: TUpdateWorkflowTemplateVersionParams
): Promise<Response> => {
  const res = await fetcher(
    `${BASE_URL}/version/${workflowTemplateVersionId}`,
    {
      method: 'POST',
      body: data,
    }
  );
  return res;
};
